const servicesForInspector = state => inspectorLegacyId => {
  if (!inspectorLegacyId) {
    return state.records;
  }

  return state.records.map(serviceGroup => ({
    ...serviceGroup,
    services: serviceGroup.services.filter(service => {
      if (!service.restrictedToInspectorIds
        || service.restrictedToInspectorIds.length === 0) {
        return true;
      }
      return service.restrictedToInspectorIds.includes(inspectorLegacyId);
    }),
  }));
};

const hasServices = state => (state.records && Array.isArray(state.records)
  ? state.records.length > 0
  : false);

export default {
  servicesForInspector,
  hasServices,
};
